import * as types from '../../../../types/masters/mould/mould/mouldTypes';
import * as api from '../../../../../api/masters/mould/mould/mouldApi';

export const fetchMoulds = () => async (dispatch) => {
  dispatch({ type: types.FETCH_MOULD_REQUEST });
  try {
    const data = await api.fetchMoulds();
    dispatch({ type: types.FETCH_MOULD_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: types.FETCH_MOULD_FAILURE, payload: error.message });
  }
};

export const addMould = (mould) => async (dispatch) => {
  try {
    const res = await api.addMould(mould);
    dispatch({ type: types.ADD_MOULD_SUCCESS, payload: res });
    dispatch(fetchMoulds());
  } catch (error) {
    dispatch({ type: types.MOULD_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const updateMould = (id, mould) => async (dispatch) => {
  try {
    const res = await api.updateMould(id, mould);
    dispatch({ type: types.UPDATE_MOULD_SUCCESS, payload: res });
    dispatch(fetchMoulds());
  } catch (error) {
    dispatch({ type: types.MOULD_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const deleteMould = (id) => async (dispatch) => {
  try {
    await api.deleteMould(id);
    dispatch({ type: types.DELETE_MOULD_SUCCESS, payload: id });
    dispatch(fetchMoulds());
  } catch (error) {
    dispatch({ type: types.MOULD_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const setMouldEdit = (mould) => ({
  type: types.SET_MOULD_EDIT,
  payload: mould,
});

export const clearMouldEdit = () => ({
  type: types.CLEAR_MOULD_EDIT,
}); 